import { Stack, Typography } from "@mui/material";
import useSetTabTitle from "hooks/useSetTabTitle";
import { palette } from "theme";

const Header = () => {
  const title = "Моя компания";
  useSetTabTitle(title);

  return (
    <Stack spacing={0.5}>
      <Typography variant='h28'>{title}</Typography>
      <Typography sx={{ color: palette.text.secondary }}>
        Реквизиты, верификация и управление доступом команды
      </Typography>
    </Stack>
  );
};

export default Header;
